module.exports = __webpack_public_path__ + "img/bjb.5a81326e.png";